// extracted by mini-css-extract-plugin
module.exports = {"qqtButton":"Button_qqtButton__2hYiJ"};